import { AuthService } from "../auth.service";
import { AuthBiModeService } from "./auth-bi-mode.service";

/**
 * This initializer force authentication to load BEFORE any component.
 * This is to ensure that we do not have a concurrency problem.
 */
export function onAuthorizationBiModeInit(
  authService: AuthService,
  authBiModeService: AuthBiModeService,
): () => Promise<void> {
  return async () => {
    const oauthConfig = await authBiModeService.getOAuthConfig();
    return authService.runInitialLoginSequence(oauthConfig);
  };
}
